// 生成幂等 requestId（用于状态图生成去重）。优先 crypto.randomUUID（安全上下文可用），
// 否则回退到一个 RFC4122 v4 字符串 —— 关键：回退值仍是合法 UUID，
// 这样在非安全上下文（如通过 http://<LAN-IP>:3000 访问开发服务器，randomUUID 不可用）下，
// 后端的 uuid.Parse 仍能接受，不会 400。
export function generateRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, ch => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
